









import Vue from "vue";

// Import External Components
import ImageTile from "@miele/component-library-vue/src/components/modules/image-tile/ImageTile.vue";

// Import Models
import { RecipeShrinkedContent } from "../models/recipe.model";
import { Duration } from "../models/duration.model";
import { CommonTag, HealthTag, HiddenTag, Tag } from "../models/tag.model";

const isCommonTag = (
  tag: Tag | CommonTag | HealthTag | HiddenTag
): tag is CommonTag => (tag as CommonTag).inspirationImage != undefined;

export default Vue.extend({
  props: {
    recipe: {
      type: Object as () => RecipeShrinkedContent,
      required: true,
    },
  },
  components: {
    ImageTile,
  },
  methods: {
    getOverallDuration(durations: Array<Duration>): string {
      const durationArr = durations.filter((d: Duration) => d.isPrimary);
      if (!durationArr.length) return "";

      const durationObj = durationArr[0];
      let durationStr = durationObj.value + " ";
      switch (durationObj.value) {
        case 0:
          durationStr += durationObj.unit.zero || durationObj.unit.other;
          break;
        case 1:
          durationStr += durationObj.unit.one || durationObj.unit.other;
          break;
        case 2:
          durationStr += durationObj.unit.two || durationObj.unit.other;
          break;
        default:
          durationStr += durationObj.unit.other;
      }

      return durationStr;
    },
    getCategoryName(recipe: RecipeShrinkedContent): string {
      const category: any = recipe.tags.find(
        (t: any) => t.id === recipe.mainTagId
      );

      if (category && isCommonTag(category)) {
        return category.name;
      }

      return category.name;
    },
    clickFunction(event: MouseEvent) {
      this.$router.push({
        name: "Detail",
        params: {
          title: this.recipe.title,
          id: this.recipe.id,
        },
      });
      event.preventDefault();
    },
  },
});
